
import StoryblokComponent from '~/components/Storyblok/Component'
import breakpointMixin from '~/mixins/breakpoints'

export default {
  components: { StoryblokComponent },
  mixins: [breakpointMixin],
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    containerStyles() {
      const styles = {}

      styles.margin = this.getBreakpointValue(this.blok.margin)
      styles.padding = this.getBreakpointValue(this.blok.padding)

      return styles
    },
    gridStyles() {
      const styles = {}

      styles.gridTemplateColumns = this.buildGridTemplateColumns(
        this.getBreakpointValue(this.blok.columnSizes)
      )
      styles.rowGap = this.getBreakpointValue(this.blok.rowGap)
      styles.columnGap = this.getBreakpointValue(this.blok.columnGap)

      return styles
    },
    leftColumnStyles() {
      const styles = {}

      styles.placeSelf = this.getBreakpointValue(this.blok.leftColPlaceSelf)

      return styles
    },
    rightColumnStyles() {
      const styles = {}

      styles.placeSelf = this.getBreakpointValue(this.blok.rightColPlaceSelf)

      return styles
    },
  },
  // mounted() {
  //   this.$nextTick(() => {
  //     if (this.blok?.leftColumnReveal || this.blok?.rightColumnReveal)
  //       this.initAnimation()
  //   })
  // },
  methods: {
    // initAnimation() {
    //   const mm = this.$gsap.matchMedia(this.$refs.container)

    //   // add a media query. When it matches, the associated function will run
    //   mm.add('(min-width: 1024px)', () => {
    //     const tl = this.$gsap.timeline({
    //       scrollTrigger: {
    //         trigger: this.$refs.container,
    //         start: 'top bottom-=10%',
    //         toggleActions: 'play none none reverse',
    //         // markers: true,
    //       },
    //     })

    //     if (
    //       this.blok?.leftColumnReveal === 'fadeUp' &&
    //       this.blok?.leftColumn.length > 0
    //     ) {
    //       tl.from([this.$refs.leftColumn], {
    //         opacity: 0,
    //         y: 50,
    //         scale: 0.9,
    //         ease: 'back.out(.3)',
    //         // clearProps: 'all',
    //       })
    //     }
    //     if (
    //       this.blok?.rightColumnReveal === 'fadeUp' &&
    //       this.blok?.rightColumn.length > 0
    //     ) {
    //       tl.from(
    //         [this.$refs.rightColumn],
    //         {
    //           opacity: 0,
    //           y: 50,
    //           scale: 0.9,
    //           ease: 'back.out(.3)',
    //           // clearProps: 'all',
    //         },
    //         '<'
    //       )
    //     }
    //   })
    //   return
    //   this.$gsap.context(() => {
    //     const tl = this.$gsap.timeline({
    //       scrollTrigger: {
    //         trigger: this.$refs.container,
    //         start: 'top bottom-=10%',
    //         toggleActions: 'play none none reverse',
    //         // markers: true,
    //       },
    //     })

    //     if (this.blok?.leftColumnReveal === 'fadeUp') {
    //       tl.from([this.$refs.leftColumn], {
    //         opacity: 0,
    //         y: 50,
    //         scale: 0.9,
    //         ease: 'back.out(.3)',
    //         // clearProps: 'all',
    //       })
    //     }
    //     if (this.blok?.rightColumnReveal === 'fadeUp') {
    //       tl.from(
    //         [this.$refs.rightColumn],
    //         {
    //           opacity: 0,
    //           y: 50,
    //           scale: 0.9,
    //           ease: 'back.out(.3)',
    //           // clearProps: 'all',
    //         },
    //         '<'
    //       )
    //     }

    //     // .set(this.$refs.container, {
    //     //   clearProps: 'all',
    //     // })
    //   }, this.$refs.container)
    // },
    buildGridTemplateColumns(sizes) {
      if (!sizes) return null

      const [left, right] = sizes.replace(/\s/g, '').split('/')
      return left && right ? `${left}fr ${right}fr` : '1fr'
    },
    templateColumns() {
      const [left, right] = this.blok?.columns.replace(/\s/g, '').split(',')
      return left && right ? `${left}fr ${right}fr` : '1fr'
    },
  },
}
